import { DataGrid } from "devextreme-react";
import React, { useMemo, useState } from "react";
import { getPropsDataGridColSpan, getPropsDataGrid, getPropsDataGridEditing, getPropsLookupExprForIdName, getPropsDataGridPopup } from "../../../../../utils/default-props";
import { Column, Editing, FormItem, Lookup, Popup, RequiredRule } from "devextreme-react/data-grid";
import { useDataSource } from "../../../../../contexts/dataSource";
import { useAuth } from "../../../../../contexts/auth";


function PositionManagement() {

    const { user } = useAuth()
    const { dataSourceHR } = useDataSource()
    const [say, setSay] = useState(0);
    
    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: "/api/PositionInfo",
        insertUrl: "/api/PositionInfo/FormData"
    }), [user])

    const dbCompany = useMemo(() => dataSourceHR({
        loadUrl: "/api/CompanyInfo"
    }), [user])

    const dbOffice = useMemo(() => dataSourceHR({
        loadUrl: "/api/OfficeInfo"
    }), [user])

    const dbDepartment = useMemo(() => dataSourceHR({
        loadUrl: "/api/DepartmentInfo"
    }), [user])

    const dbTitle = useMemo(() => dataSourceHR({
        loadUrl: "/api/TitleInfo"
    }), [user])

    const dbParentPositionInfo = useMemo(() => dataSourceHR({
        loadUrl: "/api/PositionInfo",
    }), [user, say])
    //Listeyi yenilemek için
    const sayiArtir = () => {
        setSay(say+1)
    }

    return (
        <React.Fragment>

            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <div className="dx-form-group-caption">Pozisyon Yönetimi</div>
                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                        onRowInserted={sayiArtir}
                        onRowRemoved={sayiArtir}
                    >
                        <Editing {...getPropsDataGridEditing}>
                            <Popup {...getPropsDataGridPopup} title="Pozisyon Bilgisi" />
                        </Editing>

                        <Column dataField="name" caption="Pozisyon Adı">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />
                        </Column>
                        <Column dataField="parentPositionInfoId" caption="Üst Pozisyon">
                            <FormItem {...getPropsDataGridColSpan} />
                            <Lookup dataSource={dbParentPositionInfo} {...getPropsLookupExprForIdName} />
                        </Column>
                        <Column dataField="companyInfoId" caption="Firma">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />
                            <Lookup dataSource={dbCompany} {...getPropsLookupExprForIdName} />
                        </Column>
                        <Column dataField="officeInfoId" caption="Ofis">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />
                            <Lookup dataSource={dbOffice} {...getPropsLookupExprForIdName} />
                        </Column>
                        <Column dataField="departmentInfoId" caption="Departman">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />
                            <Lookup dataSource={dbDepartment} {...getPropsLookupExprForIdName} />
                        </Column>
                        <Column dataField="titleInfoId" caption="Ünvan">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />
                            <Lookup dataSource={dbTitle} {...getPropsLookupExprForIdName} />
                        </Column>
                    </DataGrid>
                </div>
            </div>
        </React.Fragment>
    )
}

export default PositionManagement
